<template>
    <form class="app-code-editor" @submit.prevent="execute()">
        <div class="app-code-editor__code">
            <div
                ref="console-log"
                class="app-code-editor__log">
                <pre v-for="(line, index) in output"
                    :key="`line-${index}`"
                    :class="['app-code-editor__line', `app-code-editor__${line.type}`]">{{ line.text }}</pre>
            </div>
            <div class="app-code-editor__footer">
                <p class="app-code-editor__footer-message">You may execute Artisan commands. Run <code>list</code> to view available commands.</p>
                <div class="app-code-editor__prepend">></div>
                <div class="input text is--inverse">
                    <input
                        type="text"
                        class="app-code-editor__input"
                        v-model="command"
                        ref="input"
                        @keydown.up.prevent="jump(1)"
                        @keydown.down.prevent="jump(-1)">
                </div>
                <button
                    @click="execute()"
                    :disabled="!command"
                    type="button"
                    class="element-button--primary element-button is--inverse">
                    Submit
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return {
            command: '',
            history: [],
            historyIndex: -1,
            output: []
        }
    },
    watch: {
        async output (value) {
            await this.$nextTick()
            this.$refs['console-log'].scrollTop = this.$refs['console-log'].scrollHeight
        }
    },
    methods: {
        async execute () {
            const command = this.command
            this.history.unshift(command)
            this.historyIndex = -1
            this.command = ''
            this.output.push({
                type: 'command',
                text: `> ${command}`
            })
            const data = { }
            try {
                const response = await axios.post(`/admin/console/${command}`, { data })
                const result = _.get(response, 'data.data')
                if (result) {
                    this.output.push({
                        type: 'result',
                        text: result.output.length ? result.output : 'No output.'
                    })
                }
            } catch (err) {
                console.error(err)
                this.output.push({
                    type: 'error',
                    text: `!!! Error running command [${command}] !!!`
                })
            }
        },
        jump (count) {
            if (!this.history.length) {
                return
            }

            this.historyIndex = _.clamp(this.historyIndex + count, -1, this.history.length - 1)
            if (this.historyIndex == -1) {
                this.command = ''
            } else {
                this.command = this.history[this.historyIndex]
            }

            // await this.$nextTick()
            // this.$refs['input'].focus()
            this.$refs['input'].setSelectionRange(this.command.length, this.command.length)
        }
    }
}
</script>